module.exports = __webpack_public_path__ + "static/img/4.dbbbb74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/4.jpg
// module id = D13e
// module chunks = 0